import { Box, Typography, useTheme } from "@mui/material"
import { ReactElement } from "react"

/** Fallback text for when zero search results are returned */
const ZeroApplicationsMsg = (): ReactElement => {
    const theme = useTheme()
    return (
        <Typography variant="h6" component="div">
            Your search returned{" "}
            <Box color={theme.palette.primary.main} display="inline">
                no applications 😞.
            </Box>{" "}
            Hint: try reducing the number of filters selected!
        </Typography>
    )
}

export default ZeroApplicationsMsg
